var map = {
	"./Includes/BeautifulSection.ss": 101,
	"./Includes/CollectionPagesSlider.ss": 102,
	"./Includes/ContentSections.ss": 103,
	"./Includes/CurrentActionSection.ss": 104,
	"./Includes/DiscoverMoreSection.ss": 105,
	"./Includes/Footer.ss": 106,
	"./Includes/MainSlide.ss": 107,
	"./Includes/MainSlider.ss": 108,
	"./Includes/Navigation.ss": 109,
	"./Includes/OpeningTimesSection.ss": 110,
	"./Includes/PageHeader.ss": 111,
	"./Includes/PopUp.ss": 112,
	"./Includes/ProductHeader.ss": 113,
	"./Includes/ProductPreview.ss": 114,
	"./Includes/QuickLinkBoxes.ss": 115,
	"./Includes/TextImageSection.ss": 116,
	"./Includes/TextSection.ss": 117,
	"./Layout/CollectionPage.ss": 118,
	"./Layout/ConsultingPage.ss": 119,
	"./Layout/ContactPage.ss": 120,
	"./Layout/HomePage.ss": 121,
	"./Layout/NewsletterPage.ss": 122,
	"./Layout/Page.ss": 123,
	"./Layout/ProductPage.ss": 124,
	"./Page.ss": 125
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;


//////////////////
// WEBPACK FOOTER
// ./src/templates \.ss$
// module id = 100
// module chunks = 0